import Helper from '@/components/helper.js';

function getCognitoUserPoolClientId() {
  if (Helper.isFCPExtension() && import.meta.env.VITE_AWS_USER_POOLS_FCP_CLIENT_ID) {
    return import.meta.env.VITE_AWS_USER_POOLS_FCP_CLIENT_ID;
  }

  if ((Helper.isPremiereProHost() || Helper.isAdobeExtension())
    && import.meta.env.VITE_AWS_USER_POOLS_PREMIERE_CLIENT_ID) {
    return import.meta.env.VITE_AWS_USER_POOLS_PREMIERE_CLIENT_ID;
  }

  return import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID;
}

const userPoolClientId = getCognitoUserPoolClientId();

export default {
  env: import.meta.env.VITE_ENV, // enable/disable Google Analytics on the frontend
  cast_receiver_application_id: import.meta.env.VITE_CAST_RECEIVER_APPLICATION_ID,
  aws_project_region: import.meta.env.VITE_AWS_PROJECT_REGION,
  aws_cognito_identity_pool_id: import.meta.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: import.meta.env.VITE_AWS_COGNITO_REGION,
  aws_user_pools_id: import.meta.env.VITE_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID,
  aws_user_pools_fcp_client_id: import.meta.env.VITE_AWS_USER_POOLS_FCP_CLIENT_ID,
  aws_user_pools_premiere_client_id: import.meta.env.VITE_AWS_USER_POOLS_PREMIERE_CLIENT_ID,
  aws_user_files_s3_bucket: import.meta.env.VITE_AWS_USER_FILES_S3_BUCKET,
  aws_user_files_s3_bucket_region: import.meta.env.VITE_AWS_USER_FILES_S3_BUCKET_REGION,
  recaptcha_site_key: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
  Auth: {
    Cognito: {
      //  Amazon Cognito User Pool ID
      userPoolId: import.meta.env.VITE_AWS_USER_POOLS_ID,
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolClientId,
      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      identityPoolId: import.meta.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID,
      // OPTIONAL - Set to true to use your identity pool's unauthenticated role when user is not logged in
      allowGuestAccess: true,
      // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
      // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
      // signUpVerificationMethod: 'code', // 'code' | 'link'
      loginWith: {
        // OPTIONAL - Hosted UI configuration
        oauth: {
          domain: import.meta.env.VITE_AWS_COGNITO_HOSTEDUI,
          scopes: [
            'email',
            'openid',
            'phone',
            'profile',
            'aws.cognito.signin.user.admin',
          ],
          // On some envs we don't have ssl
          redirectSignIn: [`${import.meta.env.VITE_APP_URL}/account/external`.replace('http://', 'https://')],
          redirectSignOut: [`${import.meta.env.VITE_APP_URL}/account/login`.replace('http://', 'https://')],
          responseType: 'TOKEN', // or 'token',
          // note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
  Storage: {
    S3: {
      bucket: import.meta.env.VITE_AWS_USER_FILES_S3_BUCKET,
      region: import.meta.env.VITE_AWS_USER_FILES_S3_BUCKET_REGION,
    },
  }
}
